// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cMCw","index":"styles_index__IjUO7"};